import { getImageUrl } from '../../utils/cloudinary.utils';
import { useLocale } from '../../hooks/useLocale';
import { useSettings } from '../../services/settings.api';
import ImageDisplay from '../custom/ImageDisplay';
import { Skeleton } from '../ui/skeleton';
import { useNavigate } from 'react-router-dom';

export type HeaderImageTitleProps = {
	adminTitle?: boolean;
};

const HeaderImageTitle = ({ adminTitle }: HeaderImageTitleProps) => {
	const { data: settings, isLoading: isLoadingSettings } = useSettings();

	const { t } = useLocale('client.header');
	const navigate = useNavigate();

	return (
		<div className="flex items-center space-x-4">
			<button className="cursor-pointer" onClick={() => navigate('/')}>
				<ImageDisplay
					src={
						settings?.logoId
							? getImageUrl(settings?.logoId)
							: undefined
					}
					alt="App Logo"
					isLoading={isLoadingSettings}
					rounded={false}
					className="w-10 h-10 rounded-md"
					useFallback={false}
				/>
			</button>
			<div className="">
				{!isLoadingSettings ? (
					<span className="text-lg font-semibold text-primary">
						{settings?.name} {adminTitle && t('adminPanelTitle')}
					</span>
				) : (
					<Skeleton className="w-32 h-6" />
				)}
				<p className="text-xs text-muted">{t('boutiquePlants')}</p>
			</div>
		</div>
	);
};

export default HeaderImageTitle;
